module.exports = __webpack_public_path__ + "img/1491832073.8793118a.jpg";